/**
 * @param data is a LogDataModel
 * @param enable console log provided data, default = true
 * example use: log({service: 'AppCookieService', method: 'get', value: {'value': resultValue}}, true);
 */
export function log(data: LogDataModel, enable: boolean = true) {
  if (enable) {
    console.log('logger', data);
  }
}

/**
 * service / component from log is invoke
 * method name
 * value is any type
 */
export class LogDataModel {
  service: string;
  method: string;
  value: any;
}
